import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-appointment-requests-sidebar',
  templateUrl: './appointment-requests-sidebar.component.html',
  styleUrls: ['./appointment-requests-sidebar.component.scss']
})
export class AppointmentRequestsSidebarComponent implements OnInit {
  @Input() appointmentRequestsToView: Array<any>;

  @Input() showAptReq: boolean = false;

  @Output() showAptReqChange = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  closeSidebar(): void {
    this.showAptReq = false;
    this.showAptReqChange.emit(false);
  }

}
